import React, { useState, useEffect } from "react";
import { Button, TextInputField } from "evergreen-ui";
import { useSelector } from "react-redux";

import styles from "./codeauthentication.module.css";
import {
  Captcha,
  generateString,
  validateCaptcha,
} from "../../Captcha/Captcha";
import { useNavigate } from "react-router-dom";
import { loadData, saveData } from "../../../Utils/localStorage";
import { ToastContainer, toast } from "react-toastify";
import { PRODUCT } from "../../../Utils/variables";
export const CodeAuthentication = () => {
  document.title = PRODUCT + " - Code Authentication";
  const { isLogin, vendorId } = useSelector((state) => state.auth);

  const [securityCode, setSecurityCode] = useState("");
  const [captchaValue, setCaptchaValue] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [isvisible, setIsVisible] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = () => {
    if (securityCode == "") {
      toast.error("Please enter security code ");
    } else if (captchaValue == "") {
      toast.error("Please enter  Captcha");
    } else if (!validateCaptcha(captcha, captchaValue)) {
      toast.error("Captcha not matched");
    } else {
      setIsVisible(true);
      fetch(process.env.REACT_APP_API_URL + "/api/vendor/authintecate", {
        method: "POST",
        body: JSON.stringify({
          email: loadData("forgotEmail") || "",
          key: securityCode,
        }),
        headers: { "content-type": "application/json" },
      })
        .then((d) => d.json())
        .then((res) => {
          setCaptchaValue("");
          setCaptcha(() => generateString(6));
          setIsVisible(false);
          if (res.status == true) {
            toast.success(`${res.message}`);
            saveData("key", securityCode);
            setTimeout(() => {
              navigate("/changepassword");
            }, 2000);
          } else {
            toast.warning(`${res.message}`);
          }
        })
        .catch((err) => {
          setIsVisible(false);
          console.log("e", err);
        });
    }
  };
  const handleGenerateCaptcha = () => {
    setCaptcha(() => generateString(7));
  };
  useEffect(() => {
    if (isLogin) {
      navigate("/rfqs");
    }
  }, []);
  return (
    <>
      <div
        className={
          PRODUCT === "STRATUM" || PRODUCT === "DANUBE"
            ? styles.mainDivFPST
            : styles.mainDivFP
        }
      >
        <div className={styles.topFP}>
          <h1>CODE AUTHENTICATION</h1>
          <p>We have sent a 6 digit security code to your email</p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              textAlign: "left",
              border: "1px solid lightGrey",
              borderRadius: "0.5rem",
              backgroundColor: "#fbfafa",
              padding: "4vh 2vh",
            }}
          >
            <TextInputField
              className={styles.inputDiv}
              label="6 Digit Security Code"
              placeholder="Enter Security Code"
              value={securityCode}
              onChange={(e) => setSecurityCode(e.target.value)}
            />
            <TextInputField
              className={styles.inputDiv}
              label="Captcha Code"
              placeholder="Captcha Code"
              value={captchaValue}
              onChange={(e) => setCaptchaValue(e.target.value)}
            />
            <div>
              <Captcha captcha={captcha} setCaptcha={setCaptcha} />
            </div>
            <div className={styles.instructionDivFP}>
              <p>
                Please enter the code shown in the above <br />
                text box.There are no zeros in the image.
              </p>
            </div>
            <div>
              {!isvisible ? (
                <Button
                  className={styles.nextBtnFP}
                  onClick={handleSubmit}
                  id="poppinFontLogin"
                >
                  VERIFY CODE
                </Button>
              ) : (
                <Button
                  disabled
                  className={styles.nextBtnDisabledFP}
                  id="poppinFontLogin"
                  onClick={handleSubmit}
                >
                  <i
                    className="fa fa-spinner fa-spin "
                    style={{ color: "white", marginRight: "10px" }}
                  ></i>
                  VERIFY CODE
                </Button>
              )}
            </div>
            {/* <Button onClick={handleGenerateCaptcha}>refresh</Button> */}
          </div>
        </div>
        <ToastContainer autoClose={5000} />
      </div>
    </>
  );
};
